import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Y si abandono como siempre?',
    answer: 'Este programa está diseñado específicamente para personas que siempre abandonan. El sistema es tan progresivo y claro que no necesitás motivación para seguir. Cada día sabés exactamente qué hacer, y los avances son tan graduales que tu cuerpo se adapta sin frustrarte.'
  }, {
    question: '¿Necesito experiencia previa corriendo?',
    answer: 'Para nada. El programa empieza desde cero absoluto. La primera semana combina caminata con trotes muy cortos. Es perfecto para personas completamente sedentarias que nunca corrieron en su vida.'
  }, {
    question: '¿Cuándo voy a ver resultados?',
    answer: 'Vas a notar mejoras desde la primera semana. En 2-3 semanas ya vas a poder trotar varios minutos seguidos sin cansarte tanto. Y en 8 semanas vas a completar tus primeros 5K. El progreso es constante y medible.'
  }, {
    question: '¿Cómo recibo el programa?',
    answer: 'Inmediatamente después del pago recibís un email con el acceso al programa completo en formato PDF. Lo podés descargar y empezar hoy mismo. No hay envíos físicos ni esperas.'
  }, {
    question: '¿Qué pasa si no funciona para mí?',
    answer: 'Este método ya funcionó para más de 500 personas que estaban en tu misma situación. Si seguís el plan paso a paso, vas a ver resultados. El sistema está probado y diseñado para que cualquier persona, sin importar su nivel inicial, pueda completarlo.'
  }];
  return <section ref={ref} className="py-20 px-4 bg-navy" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <motion.h2 className="text-4xl md:text-5xl font-black mb-16 text-center" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-39">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, i) => <motion.div key={i} className="bg-navy-light rounded-2xl overflow-hidden border border-accent/20" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.4,
          delay: 0.1 + i * 0.05
        }} data-id="element-41">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-accent/5 transition-colors" data-id="element-42">
                <span className="text-xl font-bold pr-4" data-id="element-43">{faq.question}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-44">
                  <ChevronDown className="text-accent flex-shrink-0" size={24} data-id="element-45" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-46">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-47">
                    <div className="px-8 pb-6" data-id="element-48">
                      <p className="text-lg text-gray-300 leading-relaxed" data-id="element-49">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}